/**
 * Token Service
 * - Access token stored in memory (not localStorage for XSS protection)
 * - Refresh token stored in httpOnly cookie (set by backend)
 */

let accessToken = null;

export function getAccessToken() {
  if (!accessToken) {
    // Try restoring from sessionStorage first, then localStorage (for cross-tab access)
    accessToken = sessionStorage.getItem('commscoach_token') || localStorage.getItem('commscoach_token');
  }
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token;
  if (token) {
    sessionStorage.setItem('commscoach_token', token);
    localStorage.setItem('commscoach_token', token);
  }
}

export function clearAccessToken() {
  accessToken = null;
  sessionStorage.removeItem('commscoach_token');
  localStorage.removeItem('commscoach_token');
}

/**
 * Decode JWT payload without verification (client-side only)
 */
export function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * Check if token is expired
 */
export function isTokenExpired(token) {
  const payload = decodeToken(token);
  if (!payload || typeof payload.exp !== 'number') return true;
  return Date.now() >= payload.exp * 1000;
}
